import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './solvingproblemdev.json'; // The JSON you provided

const SolvingProblemDev = () => {
  return (
    <div className="topic-page-container">
        {/* We can still use your Layout, but we pass the Router as children or a prop */}
        <TopicsPageLayout
            
            description="Problem-solving frameworks, debugging, and developer mindset. B2 English exercises for tech professionals."
            level="B2"
            title="Solving Problem Dev"
            image="/Images/problem-solving-dev.webp"
            seoTitle="Free English Lesson Plans: Problem Solving at Work"
            seoDescription="Problem-solving frameworks, debugging, and developer mindset. B2 English exercises for tech professionals."
        >
            {/* Map through the JSON and render everything immediately */}
            
                {topicData.map((section, index) => (
                    <div key={index} className="lesson-section-wrapper">
                        <TopicsRouter sectionData={section} />
                    </div>
                    ))}
            
        </TopicsPageLayout>
    </div>
  );
};

export default SolvingProblemDev;


